import React from 'react';

const PastDueMessage = () => (
  <div id="resurrect-card">
    <div className="top">
      <h1 className="title">Re-Enable The Information</h1>
      <p className="title-sub">
        Your account is currently disabled. Re-join The Information on your existing plan by
        updating your payment method.
      </p>
    </div>
  </div>
);

export default PastDueMessage;
